export function useSafeUrl(baseUrl, path) {
    if (!baseUrl) {
        throw new Error('Base URL is undefined or empty.');
    }
    var safeBaseUrl = baseUrl.endsWith('/') ? baseUrl : "".concat(baseUrl, "/");
    var safeUrl = safeBaseUrl + path;
    return safeUrl;
}
